import React from 'react'
import {connect} from 'react-redux'
import ScrollArrow from './scrollarrow/ScrollArrow'
import {TimelineMax,TweenMax,Power3,Power2,Power1,Back,Circ} from 'gsap'
import ScrollToPlugin from "gsap/ScrollToPlugin";
import SplitText from 'gsap/SplitText'
import AnimatedTextBlock from './text/AnimatedTextBlock'
import MultiLangText from './multilang/MultiLangText'

import MetaTags from 'react-meta-tags';

class HomePage extends React.Component {


  constructor(props){
      super()

      //console.log("Homepage",props);

      let content = props.pagesData.data.filter((item)=>{
            return (item.slug==='home')
      })[0]

      //console.log("home page",content);


      this.state = {
          content,
          animationIn_tl:null,
          animationOut_tl:null,
          showArrow:false,
          followFold: true,
          scrollPoint: 0,
          playingIntro:false,
          hideEntirePage:false
      }

      this.onScollDown = this.onScollDown.bind(this)
      this.setUpAnimateIn = this.setUpAnimateIn.bind(this)
      this.followFold = this.followFold.bind(this)
      this.resetPage = this.resetPage.bind(this)

  }

  componentDidMount(){
    this.setUpAnimateIn();
    TweenMax.to(window,.5,{scrollTo:0})

    document.querySelector('body').classList.add('intro-force-hide-header');
  }

  componentWillUnmount(){
    this.state.animationIn_tl.kill();
  }

  componentWillUpdate(newProps,newState){
    if(newProps.resetPage===true && this.props.resetPage !== true){
      this.resetPage();
    }
  }

  resetPage(){
    console.log("Reset Homepage");
      this.setState({hideEntirePage:false});
      TweenMax.to(window,.5,{scrollTo:0})
      document.querySelector('body').classList.add('intro-force-hide-header');
      this.state.animationIn_tl.restart()

  }



  setUpAnimateIn(){


      let copySentences = document.querySelector('#homePageContainer .copy').querySelectorAll('span');

      let line = document.querySelector('#homePageContainer .line');

      let body = document.querySelector('.document-body');

      let animationIn_tl = new TimelineMax()


      let copy = document.querySelector('#homePageContainer  .inner-copy')

      let copySplitText = new SplitText(copy,{type:"lines"})
      let copyLines = copySplitText.lines


      // Animate Title

      animationIn_tl.add(()=>{

        // this needs to be reset incase the user clicks on the homepage again
        document.querySelector('#homePageContainer  .copy').setAttribute('style','')
      })
      animationIn_tl.staggerFromTo(copyLines, 1.2, {opacity:0},{opacity:1}, .6, "-=0");

      animationIn_tl.from(line,1,{width:0,ease:Power2.easeOut},'-=.8')

      animationIn_tl.add(()=>{

          this.followFold();

          setTimeout(()=>{
            this.setState({showArrow:true});
            document.querySelector('body').classList.remove('intro-force-hide-header');

            TweenMax.fromTo(document.querySelector('header'),1.5,{y:-92},{y:0})
            setTimeout(()=>{
              document.querySelector('header').setAttribute('style','')
            },1550);

          },500)

          window.requestAnimationFrame(this.followFold)


      },'-=1')


      this.setState({animationIn_tl,copySplitText})

  }

  followFold(){


    let windowScrollY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;

    if(!this.state.hideEntirePage){
        // fade the copy
        if(windowScrollY>0){
          let copyAlpha = (200 - (windowScrollY))/100
            TweenMax.set(document.querySelector('#homePageContainer .copy'),{alpha:copyAlpha})

          //console.log(window.scrollY);
          if(windowScrollY>120){
            this.setState({showArrow:false})
          }
        }else{

            TweenMax.set(document.querySelector('#homePageContainer .copy'),{alpha:1})


        }


      //console.log(window.scrollY, window.innerHeight);


      // Reset the page
      if(window.scrollY>=window.innerHeight){
        console.log('hide page');
        this.setState({hideEntirePage:true})
        this.props.hidingHomepage();
        TweenMax.set(window,{scrollTo:0})
        this.state.animationIn_tl.kill();
        //document.querySelector('body').classList.remove('force-hide-header');
      }else{
        window.requestAnimationFrame(this.followFold)
      }
    }


  }

  onScollDown(){
        //this.state.animationOut_tl.play();
        //console.log("Homepage Scroll",window.scrollY,this.state.scrollPoint);

        /*
        if(window.scrollY>(this.state.scrollPoint)){
            this.refs.logo.style.top = 'auto';
            this.refs.logo.style.bottom = ((window.scrollY))+'px';
        }*/
  }




  render () {




        //if(this.state.hideEntirePage){
        //  return <div style={{height:'0px'}} />
        //}else{

            return (<div className={"full-browser home-page "+((this.state.hideEntirePage)? 'hide' : ' ')} id="homePageContainer" >
                  <div className="inner-fixed">
                    <div className="full-browser center-content">
                      <div className="hompage-intro" >
                        <div className="copy"  >
                            <div ref="textBlock" ><MultiLangText className="inner-copy" text={this.state.content.acf.intro_copy} /></div>
                            <div ref="redLine" className="line" />
                        </div>
                      </div>
                    </div>
                    {(this.state.showArrow)?
                      <ScrollArrow />
                    : null }
                  </div>

                  <MetaTags>
                    <meta name="description" content={(this.state.content.acf.meta_description)? this.state.content.acf.meta_description : ''} />
                  </MetaTags>
                </div>)

          //}
  }
}


const mapStateToProps = (state) => {
    const pagesData = state.KastnerStore.pagesData
    return{
      pagesData
    }
}

export default connect(mapStateToProps)(HomePage);



// WEBPACK FOOTER //
// ./src/modules/HomePage.js